import { render, staticRenderFns } from "./NavbarSideItems.vue?vue&type=template&id=4a457c10"
import script from "./NavbarSideItems.vue?vue&type=script&lang=js"
export * from "./NavbarSideItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports